/* UI strings — Persian (default) + English. Persian is RTL. */
const STRINGS = {
  fa: {
    lang: 'fa', dir: 'rtl',
    appName: 'پرشین OCR',
    tagline: 'رسید و فاکتور فارسی را به متن دقیق تبدیل کنید',
    // nav
    navUpload: 'تبدیل رسید', navHistory: 'تاریخچه', navSettings: 'تنظیمات',
    // home
    heroEyebrow: 'او‌سی‌آر هوشمند · کاملاً محلی',
    heroTitle: 'تبدیل رسید فارسی به متن',
    heroSub: 'عکس رسید (چاپی، جدولی یا دست‌نویس) را بارگذاری کنید تا مدل هوش مصنوعیِ بینایی، تمام متن آن را دقیق استخراج کند.',
    dropTitle: 'عکس رسید را اینجا رها کنید',
    dropHint: 'یا برای انتخاب فایل کلیک کنید · می‌توانید تصویر را Paste هم بکنید',
    takePhoto: 'گرفتن عکس',
    chooseFile: 'انتخاب فایل',
    noteLabel: 'توضیح اختیاری برای مدل (مثلاً: این فاکتور رستوران است)',
    startOcr: 'شروع تبدیل',
    processing: 'در حال تبدیل…',
    change: 'تغییر تصویر',
    // result
    resultTitle: 'متن استخراج‌شده',
    waiting: 'در انتظار تصویر…',
    copy: 'کپی', copied: 'کپی شد',
    download: 'دانلود', edit: 'ویرایش', save: 'ذخیره', cancel: 'انصراف',
    viewRaw: 'نمای متن ساده', viewFormatted: 'نمای قالب‌بندی‌شده',
    extracting: 'در حال استخراج…',
    reprocess: 'تبدیل مجدد',
    progStep1: 'در حال استخراج متن… (0/2)',
    progStep2: 'متن آماده شد — در حال استخراج اطلاعات فاکتور… (1/2)',
    progDone: '2/2 کامل شد',
    // structured
    structuredTitle: 'اطلاعات ساختاریافتهٔ فاکتور',
    merchant: 'فروشنده', branch: 'شعبه', date: 'تاریخ', time: 'ساعت', invoiceNo: 'شماره فاکتور',
    phone: 'تلفن', address: 'آدرس', payment: 'پرداخت', amountWords: 'مبلغ به حروف',
    idCheque: 'شماره چک', idAccount: 'شماره حساب', idReference: 'شماره مرجع/پیگیری',
    idTerminal: 'ترمینال', idCard: 'کارت', idSerial: 'سریال',
    item: 'کالا', qty: 'تعداد', unitPrice: 'قیمت واحد', lineTotal: 'جمع',
    subtotal: 'جمع جزء', discount: 'تخفیف', tax: 'مالیات', total: 'مبلغ کل', currency: 'واحد پول',
    // history
    historyTitle: 'تاریخچه رسیدها',
    historyEmpty: 'هنوز رسیدی تبدیل نشده است.',
    delete: 'حذف', confirmDelete: 'این رسید حذف شود؟',
    // detail
    original: 'تصویر اصلی',
    // settings
    settingsTitle: 'تنظیمات',
    language: 'زبان', theme: 'پوسته',
    modelStatus: 'وضعیت مدل بینایی',
    checkAgain: 'بررسی مجدد', online: 'در دسترس', offline: 'در دسترس نیست',
    model: 'مدل', endpoint: 'آدرس', latency: 'تأخیر',
    passes: 'تعداد اسکن', refOcr: 'او‌سی‌آر کمکی', refOcrOff: 'غیرفعال',
    about: 'درباره',
    aboutText: 'این برنامه رسید فارسی را با یک مدل زبانیِ بینایی که به‌صورت محلی روی LM Studio اجرا می‌شود، به متن تبدیل می‌کند. هیچ تصویری به سرویس ابری ارسال نمی‌شود.',
    // misc
    status: 'وضعیت', duration: 'مدت', done: 'انجام شد', error: 'خطا',
    ocrFailed: 'تبدیل ناموفق بود',
    retry: 'تلاش مجدد',
    seconds: 'ثانیه',
  },
  en: {
    lang: 'en', dir: 'ltr',
    appName: 'Persian OCR',
    tagline: 'Turn Persian receipts & invoices into accurate text',
    navUpload: 'Convert', navHistory: 'History', navSettings: 'Settings',
    heroEyebrow: 'Smart OCR · Fully on-device',
    heroTitle: 'Persian receipt → text',
    heroSub: 'Upload a receipt photo (printed, tabular, or handwritten) and a local vision LLM transcribes every bit of it faithfully.',
    dropTitle: 'Drop a receipt image here',
    dropHint: 'or click to choose a file · you can also paste an image',
    takePhoto: 'Take photo',
    chooseFile: 'Choose file',
    noteLabel: 'Optional hint for the model (e.g. this is a restaurant bill)',
    startOcr: 'Start OCR',
    processing: 'Transcribing…',
    change: 'Change image',
    resultTitle: 'Extracted text',
    waiting: 'Waiting for an image…',
    copy: 'Copy', copied: 'Copied',
    download: 'Download', edit: 'Edit', save: 'Save', cancel: 'Cancel',
    viewRaw: 'Plain text', viewFormatted: 'Formatted',
    extracting: 'Extracting…',
    reprocess: 'Re-run OCR',
    progStep1: 'Extracting text… (0/2)',
    progStep2: 'Text ready — extracting invoice data… (1/2)',
    progDone: '2/2 complete',
    structuredTitle: 'Structured invoice data',
    merchant: 'Merchant', branch: 'Branch', date: 'Date', time: 'Time', invoiceNo: 'Invoice #',
    phone: 'Phone', address: 'Address', payment: 'Payment', amountWords: 'Amount in words',
    idCheque: 'Cheque #', idAccount: 'Account #', idReference: 'Reference #',
    idTerminal: 'Terminal', idCard: 'Card', idSerial: 'Serial',
    item: 'Item', qty: 'Qty', unitPrice: 'Unit price', lineTotal: 'Total',
    subtotal: 'Subtotal', discount: 'Discount', tax: 'Tax', total: 'Total', currency: 'Currency',
    historyTitle: 'Receipt history',
    historyEmpty: 'No receipts converted yet.',
    delete: 'Delete', confirmDelete: 'Delete this receipt?',
    original: 'Original image',
    settingsTitle: 'Settings',
    language: 'Language', theme: 'Theme',
    modelStatus: 'Vision model status',
    checkAgain: 'Check again', online: 'Online', offline: 'Offline',
    model: 'Model', endpoint: 'Endpoint', latency: 'Latency',
    passes: 'OCR passes', refOcr: 'Reference OCR', refOcrOff: 'off',
    about: 'About',
    aboutText: 'This app converts Persian receipts to text using a vision LLM running locally on LM Studio. No image is sent to any cloud service.',
    status: 'Status', duration: 'Duration', done: 'Done', error: 'Error',
    ocrFailed: 'OCR failed',
    retry: 'Retry',
    seconds: 's',
  },
};

export default STRINGS;
